.flowiseView {
    ::before {
        content: '';
        position: absolute;
        top: -15px;
        left: 0;
        width: 100%;
        height: 50px;
        background-color: #304970;
        z-index: 50000000;
        pointer-events: none;
    }
}

.refreshButton {
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;

    img {
        width: 30px;
        height: 30px;
        z-index: 500000003;
        position: absolute;
        right: 10px;
        top: -5px;
        transition: transform 0.2s;
        &:active {
            filter: brightness(0.7);
        }
        &:hover {
            transform: scale(1.1);
        }
    }
}
.steps_title {
    font-family: LustTextItalic;
    font-weight: 300;
    font-size: 22px;
    color: white;
    padding: 10px 25px;
}

.step_index {
    font-family: Hanken Grotesk;
    font-weight: 500;
    font-size: 26px;
    margin-left: 15px;
    margin-right: 20px;
}

.step_title {
    font-family: Hanken Grotesk;
    font-weight: 500;
    font-size: 17px;
    padding-top: 4px;
}
